import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom';
import { LanguageList, Translate } from '../../contexts/Language';
import './login.css'
import { AuthConsumer } from '../../contexts/Auth';
import { Validator, ErrorMessage } from '../../components/Validator';

export class Login extends Component {

    constructor(props) {
        super(props)

        this.state = {
            formData: {
                AccountLogin: null,
                Password: null
            },
            validation: {
                error: false,
                message: ""
            }
        }
    }
    onChange(e) {
        let formData = this.state.formData;

        formData[e.target.name] = e.target.value;

        this.setState({
            formData
        });

    }
    onLogin(e, loginHandler) {

        if (this.isValid()) {

            loginHandler(this.state.formData, this.loadingHandler, e);

            // if (!AuthConsumer.isAuth)
            //     this.setState({
            //         validation: {
            //             error: true,
            //             message: Translate('Invalid Login Credentials')
            //         }
            //     });
        }

    }
    isValid() {


        let error = Validator.Valid(this.state.formData, this.Refs);

        this.setState({
            validation: error
        });

        return !error.error;
    }

    render() {
        return (
            <AuthConsumer>
                {({ authorized, onLogin }) => (
                    (authorized) ?
                        <Redirect to="/home" />
                        :
                        <div className="wrapper-page">
                            <div className="card account-card mx-3">
                                <div className="bg-info p-4 text-white text-center position-relative">
                                    <h4 className="font-20 m-b-5">{Translate('Personnel Panel')}</h4>
                                    <p className="text-white-50 mb-4">{Translate('Money transfer management panel.')}</p>
                                    <Link to="/login" className="logo logo-admin"><img src="assets/images/logo/logo-icon.svg" height="36" alt="logo" /></Link>
                                </div>
                                <div className="account-card-content">
                                    <ErrorMessage Validation={this.state.validation} />
                                    <form className="form-horizontal m-t-30" name="loginForm" onKeyPress={(e) => { if (e.key === 'Enter') onLogin(this.state.formData); }}>
                                        <div className="form-group">
                                            <label htmlFor="username">{Translate('User Id')}</label>
                                            <input type="email" className="form-control" id="AccountLogin" name="AccountLogin" placeholder={Translate("Enter user id")} onChange={(e) => this.onChange(e)} />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="userpassword">{Translate('Password')}</label>
                                            <input type="password" className="form-control" id="Password" name="Password" placeholder={Translate("Enter password")} onChange={(e) => this.onChange(e)} />
                                        </div>

                                        <div className="form-group row m-t-20">
                                            <div className="col-sm-6">
                                                <LanguageList />
                                            </div>
                                            <div className="col-sm-6 text-right">
                                                <button type="button" className="btn btn-info w-md waves-effect waves-light" onClick={(e) => { this.onLogin(e, onLogin) }}>{Translate('Log In')}</button>
                                            </div>
                                        </div>
                                        <div className="form-group m-t-10 mb-0 row">
                                            <div className="col-12 m-t-20">
                                                <Link to="/recoverpassword"><i className="mdi mdi-lock"></i> Forgot your password?</Link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div className="m-t-40 text-center">
                                <p>© {new Date().getFullYear()} ARTSMRKTS </p>
                            </div>
                        </div>
                )}
            </AuthConsumer>



        )
    }

}